<template>
	<div id="test-list">
		<div class="row g-3 mb-3">
			<div class="row gx-3">
				<div>
					<div
						class="card-header audience-chart-header p-0 scrollbar-overlay position-relative col-12 col-xl-9"
					>
						<ul
							class="nav nav-tabs border-0 chart-tab flex-nowrap"
							id="audience-chart-tab"
							role="tablist"
						>
							<li
								v-for="(item, index) in userData.qa"
								:key="'test-' + index"
								class="nav-item bg-light me-2"
							>
								<div
									class="nav-link mb-0 text-500 fs-0"
									:class="[
										index == current - 1 ? 'active' : '',
									]"
									@click="changeTest(`${index + 1}`)"
									id="users-tab"
									data-bs-toggle="tab"
									role="tab"
									aria-controls="users"
									aria-selected="true"
								>
									<div class="audience-tab-item p-2 px-3">
										<p
											class="ff-ch fw-medium text-center"
											>{{ item.name }}</p
										>
									</div>
								</div>
							</li>
						</ul>
						<h6
							class="c-gray-light text-alert ff-ch d-none d-md-block"
						>
							<i
								data-feather="alert-circle"
								width="18"
								stroke-width="2"
							></i>
							<span class="fs--1"> 反灰為已完成的題目</span>
						</h6>
					</div>
				</div>
			</div>
			<div class="row gx-3">
				<div class="mb-3 mt-n1 col-12 col-xl-9">
					<div class="card overflow-hidden">
						<div class="card-body">
							<div class="tab-content">
								<div
									class="tab-pane active"
									id="users"
									role="tabpanel"
									aria-labelledby="users-tab"
								>
									<div class="echart-audience">
										<router-link
											v-for="(item, index) in userData.qa[
												current - 1
											].qa"
											:key="'test-row' + index"
											:to="
												`/test/${current}/${itemList[index]}`
											"
											class="row w-97 g-0 align-items-center py-2 position-relative border-bottom border-200"
										>
											<div
												class="col ps-card py-1 position-static"
											>
												<div
													class="d-flex align-items-center"
												>
													<div
														class="avatar avatar-xl me-3"
													>
														<div
															class="avatar-name rounded-circle bg-soft-primary text-dark"
															:class="{
																'bg-danger':
																	item.answered !==
																		item.correct &&
																	remain[
																		current -
																			1
																	] <= 0,
															}"
														>
															<span
																:class="[
																	'fs-0',
																	'text-primary',
																	'ff-ch',
																	{
																		wrong:
																			item.answered !==
																				item.correct &&
																			remain[
																				current -
																					1
																			] <=
																				0,
																	},
																]"
																>{{
																	item.item >=
																	10
																		? item.item
																		: `0${item.item}`
																}}</span
															>
														</div>
													</div>
													<div class="flex-1">
														<h5
															class="mb-0 d-flex align-items-center"
														>
															<div
																:class="[
																	'lh-base ff-ch fs-0',
																	{
																		'c-gray-lighter':
																			item.answered !==
																				'' &&
																			remain[
																				current -
																					1
																			] >
																				0,
																		'text-800':
																			item.answered ===
																				'' ||
																			remain[
																				current -
																					1
																			] <=
																				0,
																		wrong:
																			item.answered !==
																				item.correct &&
																			remain[
																				current -
																					1
																			] <=
																				0,
																	},
																]"
															>
																{{ item.test }}
															</div>
														</h5>
													</div>
												</div>
											</div>
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-xl-3 mt-n1">
					<div class="card">
						<div class="card-header border-bottom px-custom">
							<h5 class="lh-base fw-bold text-primary ff-ch fs-1"
								>致謝</h5
							>
						</div>
						<div class="card-body bg-gray px-custom ff-ch lh-base">
							<p class="mt-2 mb-2 fs-0">物理治療師</p>
							<p class="text-primary fw-bold mb-2 fs-1">黃希文</p>
							<p class="mb-3 fs-0"
								>台大醫院復健部物理治療技術科</p
							>
							<p class="mt-6 mb-2 fs-0">物理治療師</p>
							<p class="text-primary fw-bold mb-2 fs-1">曾增顥</p>
							<p class="mt-2 mb-3 fs-0"
								>中國醫藥大學附設醫院復健部</p
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			// remain: [0, 30],
		};
	},

	methods: {
		changeTest(val) {
			if (this.current !== val) {
				this.$router.push(`/test/${val}`);
			}
		},
	},

	computed: {
		...mapGetters({ userData: "getUserData" }),
		current() {
			return this.$route.params.Group - 0;
		},
		remain() {
			return this.userData.qa.map((item) => item.remain);
		},
		itemList() {
			return this.userData.qa[this.current - 1].qa.map(
				(item) => item.item
			);
		},
	},

	created() {
		this.$store.commit("navLeftSwitch", "show");
	},

	mounted() {
		feather.replace();
	},
};
</script>

<style lang="scss" scoped>
.echart-audience {
	// max-height: 54vh;
	overflow-x: hidden;
	overflow-y: auto;
}

.card-header.audience-chart-header.p-0.scrollbar-overlay {
	background-color: var(--falcon-body-bg);
}

.nav-link {
	cursor: pointer;
	user-select: none;
	&.active {
		color: rgb(65, 105, 178) !important;
	}
}

.text-alert {
	position: absolute;
	top: 50%;
	right: 1rem;
	transform: translateY(-50%);
	span {
		vertical-align: middle;
	}
	svg {
		margin-right: 5px;
		fill: var(--falcon-500);
		stroke: var(--falcon-300);
	}
}

.bg-danger {
	background-color: rgba(#cf543c, 0.4) !important;
}

.px-custom {
	padding-left: 1.25rem !important;
	padding-right: 1.25rem !important;
}

@media screen and (max-width: 1200px) {
	#test-list {
		.row.g-3.mb-3 {
			.card {
				.px-custom {
					padding-left: 2.5rem !important;
				}
			}
		}
	}
}
@media screen and (max-width: 768px) {
	#test-list {
		.row.g-3.mb-3 {
			.card-header {
				ul {
					.nav-item.bg-light.me-2 {
						width: 50%;
					}
					.nav-item.bg-light.me-2:last-child {
						margin-right: 0 !important;
					}
				}
			}
		}
	}
}

// X-Large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
	.echart-audience {
		max-height: 60vh;
	}
}
</style>
